import React from 'react'

import Page from '../../../../components/pdf/Page'

import Header from './Header'
import Content from './Content'

const WorkSafetyReport = () => {
  return (
    <Page>
      <Header />
      <Content />
    </Page>
  )
}

export default WorkSafetyReport
